import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/view-constants';

const ConceptFamilyDetailsInfo = ({ data = {}, variant, termWidth }) => {
  return (
    <DescriptionList
      data={data}
      stripEmpty={true}
      disableGutters={true}
      termWidth={termWidth}
      variant={variant}
    >
      <DescriptionItem
        label={'Last updated by'}
        type={'metadata'}
        value={data}
        userField={CONCEPT_FAMILY.UPDATED_BY}
        dateField={CONCEPT_FAMILY.UPDATED_DATE}
      />
      <DescriptionItem
        label={'Created by'}
        type={'metadata'}
        value={data}
        userField={CONCEPT_FAMILY.CREATED_BY}
        dateField={CONCEPT_FAMILY.CREATED_DATE}
      />
    </DescriptionList>
  );
};

export default ConceptFamilyDetailsInfo;
